// extracted by mini-css-extract-plugin
export default {"fields":"lz52I","month":"_3fSmt","day":"pYMHx","year":"sAELK"};